<mat-tab-group mat-stretch-tabs="false">
  <mat-tab label="Zielbaumansicht" i18n-label>
    <ng-template matTabContent>
      <dt-quickstart-hierarchies></dt-quickstart-hierarchies>
    </ng-template>
  </mat-tab>
  <mat-tab label="Listenansicht" i18n-label>
    <ng-template matTabContent>
      <dt-quickstart-objectives></dt-quickstart-objectives>
    </ng-template>
  </mat-tab>
</mat-tab-group>
